/*----------------------
   FEATURED PRODUCTS
---------------------- */

productsSlider = {
    init: function () {
        new Swiper('.swiper--featured-products', {
            slidesPerView: "auto",
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
            navigation: {
                nextEl: '.section-featured-products .btn--next',
                prevEl: '.section-featured-products .btn--prev',
            },
        });
    }
};


$(function () {
    productsSlider.init();
});